import { render, staticRenderFns } from "./ForestHeader.vue?vue&type=template&id=96ac6418&scoped=true&"
import script from "./ForestHeader.vue?vue&type=script&lang=ts&"
export * from "./ForestHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ForestHeader.vue?vue&type=style&index=0&id=96ac6418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ac6418",
  null
  
)

export default component.exports